(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["main-article"]) return;
  try {
    
function initSocialShare(button) {
  button.addEventListener('click', function(event){
    event.preventDefault();
    var social = button.getAttribute('data-social');
    var url = getSocialUrl(button, social);
    (social == 'mail')
      ? window.location.href = url
      : window.open(url, social+'-share-dialog', 'width=626,height=436');
  });
};

function getSocialUrl(button, social) {
  var params = getSocialParams(social);
  var newUrl = '';
  for(var i = 0; i < params.length; i++) {
    var paramValue = button.getAttribute('data-'+params[i]);
    if(params[i] == 'hashtags') paramValue = encodeURI(paramValue.replace(/\#| /g, ''));
    if(paramValue) {
      (social == 'facebook') 
        ? newUrl = newUrl + 'u='+encodeURIComponent(paramValue)+'&'
        : newUrl = newUrl + params[i]+'='+encodeURIComponent(paramValue)+'&';
    }
  }
  if(social == 'linkedin') newUrl = 'mini=true&'+newUrl;
  return button.getAttribute('href')+'?'+newUrl;
};

function getSocialParams(social) {
  var params = [];
  switch (social) {
    case 'twitter':
      params = ['text', 'hashtags'];
      break;
    case 'facebook':
    case 'linkedin':
      params = ['url'];
      break;
    case 'pinterest':
      params = ['url', 'media', 'description'];
      break;
    case 'mail':
      params = ['subject', 'body'];
      break;
  }
  return params;
};

var socialShare = document.getElementsByClassName('js-social-share');
if(socialShare.length > 0) {
  for( var i = 0; i < socialShare.length; i++) {
    (function(i){initSocialShare(socialShare[i])})(i);
  }
}



function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement("textarea");
  textArea.value = text;
  
  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    console.log('Fallback: Copying text command was ' + msg);
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }

  document.body.removeChild(textArea);
}
function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(function() {
    console.log('Async: Copying to clipboard was successful!');
  }, function(err) {
    console.error('Async: Could not copy text: ', err);
  });
}

var copyBtn = document.querySelector('.js-copy-btn');
var copyLink = document.getElementById("copylinkInput");
copyBtn.addEventListener('click', function(event) {
  event.preventDefault();
  alert("Text Copied!")
  copyTextToClipboard(copyLink.value);
});




  } catch(e) { console.error(e); }
})();

})();
